import { ComponentView } from "binder";
import { getAsBoolean, getAsNumber } from "../../../utilities";
import { NumericFilterViewModel } from "./numericFilter-viewModel"

export class NumericFilterView extends ComponentView<NumericFilterViewModel>{
    GetViewUniqueId(): string {
        return "V-6F68E110-2E17-41C1-BC25-F2670381FC66"
    }
    loadHtml(): string {
        let element = require('./numericFilter.html').default;
        let style = require('./numericFilter.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isActive(v: boolean) { this._isActive =getAsBoolean(v); } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set largerThan(v: number) { this._largerThan = getAsNumber(v, true); } public get largerThan(): number { return this._largerThan;} private _largerThan: number;
    public set smallerThan(v: number) { this._smallerThan = getAsNumber(v, true); } public get smallerThan(): number { return this._smallerThan;} private _smallerThan: number;
    public set applylarger(v: boolean) { this._applylarger =getAsBoolean(v); } public get applylarger(): boolean { return this._applylarger;} private _applylarger: boolean;
    public set applySmaller(v: boolean) { this._applySmaller =getAsBoolean(v); } public get applySmaller(): boolean { return this._applySmaller;} private _applySmaller: boolean;

    apply(){
        this.isActive = true;
        this.dataContext.apply();
    }

    removeFilter(){
        this.isActive = false;
        this.dataContext.apply();
    }

    
    onkeydown(e:KeyboardEvent){
        if(e.key=="Enter"){
            this.apply();
        }
    }
}
